module.exports = __webpack_public_path__ + "img/369A1C53-8D93-414a-B7A6-212CBE079EB2.780f4558.png";